import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./datatable.jsx";
import { getAllOrdersApiRedux, getAllEmployeeRedux } from "../../actions/index";
import { Link } from "react-router-dom";
import UpdateRequestModal from "./updateRequestModal";
import {
  getSingleOrderApi,
  updateAllOrdersApi,
} from "../../firebase/firebase.utils.js";
import { GetAllShippingAddress } from "../../actions/get1688Data";
import { get1688TrackingStatus2 } from "../../actions/get1688Data.js";
import { connect } from "react-redux";
import {
  Search,
  Package,
  Navigation,
  ShoppingBag,
  Box,
  Globe,
  FileText,
  TrendingDown,
  TrendingUp,
} from "react-feather";
import "../1688-taobao-orders/orders-kido.css";
import "./pre-orders-kido.css";
import { ClipLoader } from "react-spinners";
import { updateOrdersWithTrackingNoRedux } from "../../actions/index";
import { notifyWarning, notifyError } from "../../utils/notify";
import { toLocalDateString } from "../../utils/localDate";

// Title and playroom tone for each pre-order page (keyed by the route's
// :orderStatus). "Zapai-warehouse" is the route path; only the title changes.
const PRE_ORDER_PAGES = {
  new: { title: "New orders", tone: "sky" },
  "picked-orders": { title: "Picked orders", tone: "butter" },
  purchased: { title: "Purchased", tone: "lilac" },
  "received-in-warehouse": { title: "Abroad warehouse", tone: "lilac" },
  "ready-for-fly": { title: "Ready for fly", tone: "peach" },
  "bangladesh-customs": { title: "Bangladesh customs", tone: "butter" },
  "custom-released": { title: "Custom released", tone: "mint" },
  "Zapai-warehouse": { title: "KIDO warehouse", tone: "mint" },
  delivered: { title: "Delivered", tone: "mint" },
};
export class New extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchFor: "",
      toggleModal: true,
      toggleDeleteModal: true,
      order: null,
      loader1: false,
      shippingAddress: [],
    };
  }

  componentDidMount = async () => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);

    // Format: YYYY-MM-DD, local day (consistent everywhere)
    const endDate = toLocalDateString(today);
    const startDate = toLocalDateString(past);
    this.setState({
      customStart: startDate,
      customEnd: endDate,
    });
    console.log(this.props.match.params.orderStatus);
    this.props.getAllEmployeeRedux();
    if (this.props.match.params.orderStatus == "all-orders") {
      this.props.getAllOrdersApiRedux("", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "new") {
      this.props.getAllOrdersApiRedux("pending", startDate, endDate);
      let shippingAddress = await GetAllShippingAddress();
      console.log(shippingAddress);
      this.setState({
        shippingAddress: shippingAddress,
      });
    } else if (this.props.match.params.orderStatus === "purchased") {
      this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
    } else if (
      this.props.match.params.orderStatus === "received-in-warehouse"
    ) {
      this.props.getAllOrdersApiRedux(
        "Received in Warehouse",
        startDate,
        endDate,
      );
    } else if (this.props.match.params.orderStatus === "ready-for-fly") {
      this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "bangladesh-customs") {
      this.props.getAllOrdersApiRedux("Bangladesh customs", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "custom-released") {
      this.props.getAllOrdersApiRedux(
        "Bangladesh warehouse",
        startDate,
        endDate,
      );
    } else if (this.props.match.params.orderStatus === "Zapai-warehouse") {
      this.props.getAllOrdersApiRedux("Zapai warehouse", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "delivered") {
      this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "rejected") {
      this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "picked-orders") {
      this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
    }
  };

  componentWillReceiveProps = async (nextProps) => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);

    // Format: YYYY-MM-DD, local day (consistent everywhere)
    const endDate = toLocalDateString(today);
    const startDate = toLocalDateString(past);

    if (
      this.props.match.params.orderStatus !== nextProps.match.params.orderStatus
    ) {
      this.setState({
        customStart: startDate,
        customEnd: endDate,
        searchFor: "",
        order1688: null,
      });
      if (nextProps.match.params.orderStatus === "all-orders") {
        this.props.getAllOrdersApiRedux("", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "new") {
        this.props.getAllOrdersApiRedux("pending", startDate, endDate);
        if (this.state.shippingAddress.length == 0) {
          let shippingAddress = await GetAllShippingAddress();
          console.log(shippingAddress);
          this.setState({
            shippingAddress: shippingAddress,
          });
        }
      } else if (nextProps.match.params.orderStatus === "purchased") {
        this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
      } else if (
        nextProps.match.params.orderStatus === "received-in-warehouse"
      ) {
        this.props.getAllOrdersApiRedux(
          "Received in Warehouse",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "ready-for-fly") {
        this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "custom-released") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh warehouse",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "Zapai-warehouse") {
        this.props.getAllOrdersApiRedux(
          "Zapai warehouse",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "delivered") {
        this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "rejected") {
        this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "picked-orders") {
        this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
      }
    }
  };

  startToggleModal = async (order) => {
    if (order == null) {
      this.setState({
        toggleModal: !this.state.toggleModal,
        order: null,
      });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        order,
      });
    }
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  applyRange = async () => {
    const { customStart, customEnd } = this.state;
    this.setState({
      order1688: null,
      searchFor: "",
    });
    let startDate = customStart;
    let endDate = customEnd;
    console.log(customStart);
    console.log(customEnd);
    if (customStart && customEnd) {
      if (this.props.match.params.orderStatus == "all-orders") {
        this.props.getAllOrdersApiRedux("", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "new") {
        this.props.getAllOrdersApiRedux("pending", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "purchased") {
        this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
      } else if (
        this.props.match.params.orderStatus === "received-in-warehouse"
      ) {
        this.props.getAllOrdersApiRedux(
          "Received in Warehouse",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "ready-for-fly") {
        this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "custom-released") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh warehouse",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "Zapai-warehouse") {
        this.props.getAllOrdersApiRedux(
          "Zapai warehouse",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "delivered") {
        this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "rejected") {
        this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "picked-orders") {
        this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
      }
    }
  };

  handleSubmit2 = async (e) => {
    e.preventDefault();
    if (!this.state.searchFor) {
      notifyWarning("Order Id cant be empty.");
      return;
    }
    let order = await getSingleOrderApi(this.state.searchFor);
    if (order) {
      this.setState({
        order1688: order,
      });
    } else {
      notifyError("Sorry no order is found with this order Id");
    }
    console.log("handle submit 2 is getting called!");
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  getAllTrackingNo = async (orders) => {
    if (orders && orders.length > 0) {
      if (this.state.loader1) {
        return;
      }
      this.setState({
        loader1: true,
      });
      let newOrders = [];
      for (let i = 0; i < orders.length; i++) {
        const order = orders[i];
        let trackingArray = await get1688TrackingStatus2(order.orderNumber);
        let trackingObj = trackingArray ? trackingArray[0] : null;

        console.log(trackingObj);
        if (trackingObj && trackingObj.logisticsBillNo) {
          newOrders.push({ ...order, trackingNo: trackingObj.logisticsBillNo });
        }
      }
      this.props.updateOrdersWithTrackingNoRedux(newOrders);

      this.setState({
        loader1: false,
      });
      console.log(newOrders);
    } else {
      notifyWarning("At least select one order to get 1688 Tracking No");
    }
  };

  render() {
    const { open, customStart, customEnd } = this.state;
    const { orderStatus } = this.props.match.params;
    let { ordersApi } = this.props;
    let orders = [];
    let totalWeight = 0;
    let totalRmb = 0;
    let totalBdt = 0;
    let totalExpense = 0;
    let totalProfit = 0;

    if (ordersApi.length > 0) {
      if (this.props.match.params.orderStatus == "new") {
        orders = ordersApi.filter((order) => order.agentStatus !== "Picked");
        orders = orders.sort((a, b) => b.time - a.time);
      } else {
        orders = ordersApi.sort((a, b) => b.time - a.time);
      }
      orders.map((order) => {
        totalWeight +=
          order.items && order.items[0] && order.items[0].weight
            ? parseFloat(order.items[0].weight)
            : 0;
        if (
          order.creationTime1688 &&
          order.creationTime1688.totalSuccessAmount
        ) {
          totalRmb += parseFloat(order.creationTime1688.totalSuccessAmount);
          totalExpense += parseFloat(
            order.creationTime1688.totalSuccessAmount * order.exchangeRate,
          )
            ? parseFloat(order.creationTime1688.totalSuccessAmount) *
              order.exchangeRate
            : 0;
        }
        totalBdt +=
          order.orderTotal +
          (order.localShipping ? parseFloat(order.localShipping) : 0);
      });
    }
    totalProfit = totalBdt - totalExpense;
    console.log(this.props);
    const addressIdsToRemove = [
      7244042096, 7272087113, 7266937923, 5519749109, 7171860698, 7272015579,
    ];
    const filteredAddresses = this.state.shippingAddress.filter(
      (item) => !addressIdsToRemove.includes(item.id),
    );
    return (
      <Fragment>
        <UpdateRequestModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          order={this.state.order}
        />

        <Breadcrumb
          title={(PRE_ORDER_PAGES[orderStatus] || {}).title || orderStatus}
          parent="Pre-orders"
        />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card kd-orders-card">
                <div className="kd-ord-top">
                  <div className="kd-ord-title">
                    <span
                      className={`kd-ord-title-tile kd-st--${(PRE_ORDER_PAGES[orderStatus] || {}).tone || "sky"}`}
                      aria-hidden="true"
                    >
                      <Package size={20} />
                    </span>
                    <div>
                      <h2>{(PRE_ORDER_PAGES[orderStatus] || {}).title || orderStatus}</h2>
                      <svg className="kd-squiggle" viewBox="0 0 120 10" aria-hidden="true" focusable="false">
                        <path d="M2 6 Q12 1 22 6 T42 6 T62 6 T82 6 T102 6 T118 5" />
                      </svg>
                    </div>
                  </div>

                  <form className="kd-ord-search" onSubmit={this.handleSubmit2}>
                    <Search
                      size={16}
                      aria-hidden="true"
                      onClick={(e) => this.handleSubmit2(e)}
                    />
                    <input
                      name="searchFor"
                      value={this.state.searchFor}
                      type="search"
                      placeholder="Search by order ID"
                      aria-label="Search pre-orders by order ID"
                      onChange={this.handleSearchBarChange}
                    />
                  </form>

                  <button
                    type="button"
                    className="kd-balance kd-balance--sky"
                    disabled={this.state.loader1}
                    onClick={() => {
                      let ordersWithOrderNumber = orders.filter(
                        (order) => order.orderNumber && !order.trackingNo,
                      );
                      this.getAllTrackingNo(ordersWithOrderNumber);
                    }}
                  >
                    <span className="kd-balance-icon" aria-hidden="true">
                      <Navigation size={16} />
                    </span>
                    <span>
                      <small>1688 tracking numbers</small>
                      <strong>
                        {this.state.loader1 ? (
                          <span className="kd-hop" aria-label="Fetching">
                            <i />
                            <i />
                            <i />
                          </span>
                        ) : (
                          "Fetch missing"
                        )}
                      </strong>
                    </span>
                  </button>
                </div>

                <div className="kd-ord-summary">
                  <div className="kd-ord-dates">
                    <input
                      type="date"
                      className="kd-date-input"
                      name="customStart"
                      aria-label="From date"
                      value={customStart}
                      onChange={this.handleChange}
                    />
                    <span className="kd-muted" aria-hidden="true">to</span>
                    <input
                      type="date"
                      className="kd-date-input"
                      name="customEnd"
                      aria-label="To date"
                      value={customEnd}
                      onChange={this.handleChange}
                      min={customStart}
                    />
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={this.applyRange}
                    >
                      Apply
                    </button>
                  </div>

                  <div className="kd-ord-stats">
                    {[
                      { label: "Orders", value: orders.length, tone: "sky", Icon: ShoppingBag },
                      { label: "Weight", value: `${parseFloat(totalWeight).toFixed(2)} kg`, tone: "ink", Icon: Box },
                      { label: "RMB", value: `¥ ${parseFloat(totalRmb).toFixed(2)}`, tone: "lilac", Icon: Globe },
                      { label: "BDT", value: `৳ ${parseFloat(totalBdt).toFixed(2)}`, tone: "butter", Icon: FileText },
                      { label: "Expense", value: `৳ ${parseFloat(totalExpense).toFixed(2)}`, tone: "rose", Icon: TrendingDown },
                      { label: "Profit", value: `৳ ${parseFloat(totalProfit).toFixed(2)}`, tone: "mint", Icon: TrendingUp },
                    ].map(({ label, value, tone, Icon }, i) => (
                      <div
                        key={label}
                        className={`kd-stat-tag kd-st--${tone}`}
                        style={{ "--i": i }}
                      >
                        <span className="kd-stat-label">
                          <Icon size={13} aria-hidden="true" />
                          {label}
                        </span>
                        <span className="kd-stat-value">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ── TABLE ── */}
                <div className="card-body kd-ord-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical kd-pre-table">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      startDeleteToggleModal={this.startDeleteToggleModal}
                      history={this.props.history}
                      orderStatus={this.props.match.params.orderStatus}
                      multiSelectOption={false}
                      myData={
                        this.state.order1688 ? [this.state.order1688] : orders
                      }
                      shippingAddress={filteredAddresses}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ordersApi: state.orders.ordersApi,
  };
};

export default connect(mapStateToProps, {
  getAllOrdersApiRedux,
  getAllEmployeeRedux,
  updateOrdersWithTrackingNoRedux,
})(New);
